/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt, getConfig } from '../../twd'

export const Table = ({chartData}) => {
    const isBlue = getConfig('entitlements.ETradeBlue', 'No') === 'Yes'
    const color = isBlue ? '#e9f2f9' : '#f3f0ff'
    return <React.Fragment>
        <table className="table table-striped">
        <thead style={{borderBottomWidth:'medium'}}>
            <tr>
                <th className='text-left' style={{width:'33%'}}>Price</th>
                <th className='text-left' style={{width:'33%'}}>Yield to Maturity</th>
                <th className='text-right' style={{width:'33%'}}>Yield to Call</th>
            </tr>
        </thead>
        <tbody>
            {chartData.map( ({price, ytm, ytc}, i) => {
                let style = i===4 ? {backgroundColor:color} :{}
                return <tr className={'text-right ' + (i===4 ? 'text-bold' : '')} style={style}>
                    <td className="text-left" style={{fontVariantNumeric: 'tabular-nums'}}>
                        {alignNum(price, 3, 3)}
                    </td>
                    <td className="text-left" style={{fontVariantNumeric: 'tabular-nums'}}>
                        {alignNum(ytm, 3, 4)}
                    </td>
                    <td>{fmt.ytw3(ytc)}</td>
                </tr>
            })}
        </tbody>
        </table>
    </React.Fragment>
}

const alignNum = (num, digits = 2, intWidthCh = 3) => {
    const x = parseFloat(num)
    if (isNaN(x)) return fmt.empty()
    
    const [i, d] = x
        .toLocaleString('en-US', {minimumFractionDigits: digits, maximumFractionDigits: digits})
        .split('.')
    return <React.Fragment>
        <span style={{
            display: 'inline-block', 
            width: `${intWidthCh}ch`, 
            textAlign: 'right'
        }}>{i}</span>{d ? '.' + d : ''}
    </React.Fragment>
}